
//    :disabled="form.disabled"
import { Component, Prop, Vue } from 'vue-property-decorator';
import LoyaltyCertTypeAddForm from '@/form/loyalty/loyaltyCertType/LoyaltyCertTypeAddForm';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
import { TreeSelect } from 'ant-design-vue';
import moment from 'moment';

@Component({
    components: { FormGroup, TreeSelect },
    methods: { moment }
})
export default class LoyaltyCertTypeAddComponent extends Vue {
    // treeData: any[];
    // treeDataProduct: any = [];
    // value: any[];
    @Prop() form!: LoyaltyCertTypeAddForm;
    constructor() {
        super();
        // const SHOW_PARENT = TreeSelect.SHOW_PARENT;
        // this.value = ['0-0-0'];
        // console.log(TreeSelect.name);
        // (this.treeData = [
        //     {
        //         title: 'Аппаратное удаление волос женщины',
        //         value: '0-0',
        //         key: '0-0',
        //         children: [
        //             {
        //                 title: 'Бедра полностью',
        //                 value: '0-0-0',
        //                 key: '0-0-0'
        //             },
        //             {
        //                 title: 'Бедра частично',
        //                 value: '0-0-0',
        //                 key: '0-0-0'
        //             }
        //         ]
        //     },
        //     {
        //         title: 'Аппаратное удаление волос лица мужчины',
        //         value: '0-1',
        //         key: '0-1',
        //         children: [
        //             {
        //                 title: 'Бедра полностью',
        //                 value: '0-1-0',
        //                 key: '0-1-0',
        //                 disabled: true
        //             },
        //             {
        //                 title: 'Бедра частично',
        //                 value: '0-1-1',
        //                 key: '0-1-1'
        //             },
        //             {
        //                 title: 'Бедра',
        //                 value: '0-1-2',
        //                 key: '0-1-2'
        //             }
        //         ]
        //     }
        // ]),
        // (this.treeDataProduct = [
        //     {
        //         title: 'Основыне товары',
        //         value: '0-0',
        //         key: '0-0',
        //         children: [
        //             {
        //                 title: 'MESOMATRIX сыворотка МИКС из гиалуроновой кислоты, 100',
        //                 value: '0-0-0',
        //                 key: '0-0-0'
        //             },
        //             {
        //                 title: 'MESOMATRIX сыворотка МИКС из гиалуроновой кислоты, 30',
        //                 value: '0-0-0',
        //                 key: '0-0-0'
        //             }
        //         ]
        //     },
        //     {
        //         title: 'Расходники',
        //         value: '0-1',
        //         key: '0-1',
        //         children: [
        //             {
        //                 title: 'Шпатель деревянный А-И 100 шт/уп',
        //                 value: '0-1-0',
        //                 key: '0-1-0',
        //                 disabled: true
        //             },
        //             {
        //                 title: 'Бумага',
        //                 value: '0-1-1',
        //                 key: '0-1-1'
        //             },
        //             {
        //                 title: 'Бритва одноразовая',
        //                 value: '0-1-2',
        //                 key: '0-1-2'
        //             }
        //         ]
        //     }
        // ]);
    }
    handleOpeningDateChange(value: any): void {
        this.form.active_to = value.format('DD-MM-YYYY');
    }
}
